import store from './store'
import {loadUserFromDb, logInUser, registerUserDb, logoutUserDb} from '../dbApi/DbApi'
import throttle from 'lodash/throttle';
import {dbGetOptionMetaData, getOptions, getTreeData, dbUploadTreeContext, checkUrlAmazonConection, getExtendedScores, getTreeContext} from '../dbApi/DbApi'

/* **************** action types ************* */

/* INIT ACTIONS */
export const SET_CAN_SHOW_AMAZON_LINKS = "SET_CAN_SHOW_AMAZON_LINKS"


/* TREE DATA ACTIONS: */
export const SET_NODES_DATA = 'SET_NODES_DATA'
export const SET_NODE_DATA = 'SET_NODE_DATA'
export const SET_NODE_META_DATA = 'SET_NODE_META_DATA'
export const SET_NODE_PATH_TO_DATA = 'SET_NODE_PATH_TO_DATA'
export const SET_NODE_SCORE_FUNCTION = 'SET_NODE_SCORE_FUNCTION'
export const SET_NODE_DEF_WIGHT = 'SET_NODE_DEF_WIGHT'

export const SET_TREE_CONTEXT = "SET_TREE_CONTEXT"
export const SET_NODE_CONTEXT = "SET_NODE_CONTEXT"
export const SET_NODE_FUNCTION_DATA = "SET_NODE_FUNCTION_DATA"

export const UPLOAD_CONTEXT_SENT = "UPLOAD_CONTEXT_SENT"
export const UPLOAD_CONTEXT_SUCCESS  = "UPLOAD_CONTEXT_SUCCESS"
export const UPLOAD_CONTEXT_FAIL = "UPLOAD_CONTEXT_FAIL"

export const  SET_NODE_WIGHT = "SET_NODE_WIGHT"
export const SET_TREE_BUILD_DATA = 'SET_TREE_BUILD_DATA'
export const SET_TREE_META_DATA = 'SET_TREE_META_DATA'
export const SET_PICKED_NODE_ID = 'SET_PICKED_NODE_ID'
export const SET_PICKED_TREE_ID = 'SET_PICKED_TREE_ID'
export const SET_TREE_DATA = "SET_TREE_DATA"

/* USER_LOADING ACTIONS: */
export const USER_LOADING = "USER_LOADING"
export const USER_LOADED = "USER_LOADED"
export const AUTH_ERROR = "AUTH_ERROR"


/* LOGIN ACTIONS: */
export const LOG_IN_SENT = "LOG_IN_SENT"
export const LOG_IN_FULFILLED = "LOG_IN_FULFILLED"
export const LOG_IN_REJECTED = "LOG_IN_REJECTED"

/* LOG_OUT ACTIONS */
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS"
export const LOGOUT_FAULIRE = "LOGOUT_FAULIRE"

/* REGISTER ACTIONS: */
export const REGISTER_SENT = "REGISTER_SENT"
export const REGISTER_SUCCESS = "REGISTER_SUCCESS"
export const REGISTER_FAIL = "REGISTER_FAIL"


/* OPTIONS ACTIONS */
export const SET_CHOSEN_OPTION_CATEGORY = "SET_CHOSEN_OPTION_CATEGORY"
export const SET_OPTION_META_DATA = "SET_OPTION_META_DATA"
export const SET_OPTIONS = "SET_OPTIONS"
export const RESORT_OPTIONS = "RESORT_OPTIONS"

export const LOADING_OPTIONS = "LOADING_OPTIONS"
export const LOADED_OPTIONS = "LOADED_OPTIONS"
export const SET_PAGINTATION_DATA = "SET_PAGINTATION_DATA"
export const ERROR_LOADING_OPTIONS = "ERROR_LOADING_OPTIONS"
export const CHECK_UPDATE = "CHECK_UPDATE";
export const CALCULTE_SCORE = "CALCULTE_SCORE";

export const ADD_OPTION_COMPARE = "ADD_OPTION_COMPARE";
export const REMOVE_OPTION_COMPARE = "REMOVE_OPTION_COMPARE";

export const ADD_OPTION_QUERY_PARAM = "ADD_OPTION_QUERY_PARAM"
export const DELETE_OPTION_QUERY_PARAM = "DELETE_OPTION_QUERY_PARAM"


export const SET_OPTIONS_DISPLAY = "SET_OPTIONS_DISPLAY"
export const SET_CONTROL_OPTIONS_DISPLAY = "SET_CONTROL_OPTIONS_DISPLAY"

export const SET_PREFERNCE_ITEM = "SET_PREFERNCE_ITEM"

export const INCREASE_COUNTER = "INCREASE_COUNTER"
export const DECREASE_COUNTER = "DECREASE_COUNTER"

/* ********************** PROCESSES MANGER ********************************** */
/* ### PROCESSES ACTIONS ### */
export const ADD_PROCESS = "ADD_PROCESS"
export const SET_PROCESS_STATE = "SET_PROCESS_STATE"
export const DELETE_PROCESS = "DELETE_PROCESS"

/* ### PROCESSES STATES ### */
export const RUNNING = "RUNNING"
export const SUCSSES = "SUCSSES"
export const ERROR = "ERROR"

/* ### ERRORS ACTIONS */
export const ADD_ERROR = "ADD_ERROR"
export const SET_ERRORS = "SET_ERRORS"
export const CLEAN_ERRORS = "CLEAN_ERRORS"

export const SET_EXTENDED_SCORES = "SET_EXTENDED_SCORES"


export const SET_CUR_DISPLAY = "SET_CUR_DISPLAY"


/* ### FILTERS ### */
export const ADD_FILTER = "ADD_FILTER"
export const DELETE_FILTER = "DELETE_FILTER"

export const ADD_BREAD_CRUMB ="ADD_BREAD_CRUMB"


/* **************** init actions **************** */
export const setAmazonLinks = (amazonLinkState) => async (dispatch, getState) => {
  dispatch({
      type:SET_CAN_SHOW_AMAZON_LINKS,
      payload: amazonLinkState,
    })
}

/* **************** action creators ************* */

export const addOptionCompare = (option) => ({
  type:ADD_OPTION_COMPARE,
  payload: option
})

export const removeOptionCompare = (option) => ({
  type: REMOVE_OPTION_COMPARE,
  payload: option
})

export const setDisplay = (screen) => ({
  type:SET_CUR_DISPLAY,
  payload: screen
})

const _addProcess = processId => ({type: ADD_PROCESS,
                                          payload:{
                                            id: processId,
                                            status: "RUNNING"
                                          }})

const _setProcessState = (processId, state) => ({type: SET_PROCESS_STATE,
          payload:{
            id: processId,
            status: state
          }})

const _addError = (processId, error) => ({type: ADD_ERROR,
          payload:{
            id: processId,
            error: error
          }})

const _setErrors = (processId, errors) => ({type: SET_ERRORS,
          payload:{
            id: processId,
            errors: errors
          }})

const _cleanErrors = (processId, error) => ({type: CLEAN_ERRORS,
          payload: processId,
          })

export const checkUpdate = () => ({
  type:CHECK_UPDATE,
  payload: null
})

export const calculteScores = (options) => ({
  type:CALCULTE_SCORE,
  payload: options
})

export const setTreeMetaData = (newMetaData) => ({
  type:SET_TREE_META_DATA,
  payload:newMetaData
})

export const setNodeData = (id, nodeData) => ({
    type: SET_NODE_DATA,
    payload: {
      id: id,
      data:nodeData,
    },
})


export const setNodeMetaData = (id, nodesMetaData) => ({
    type: SET_NODE_META_DATA,
    payload: {
      id: id,
      metaData:nodesMetaData,
    },
})

export const setNodePathToData = (id, nodesPathToData) => ({
  type: SET_NODE_PATH_TO_DATA,
  payload: {
    id: id,
    pathToData:nodesPathToData,
  },
})

export const setNodeScoreFunction = (id, nodesScoreFunction) => ({
  type: SET_NODE_SCORE_FUNCTION,
  payload:{
    id: id,
    scoreFunction:nodesScoreFunction,
  }
})

export const setNodeDefWight = (id, nodesDefWight) => ({
  type: SET_NODE_DEF_WIGHT,
  payload: {
    id: id,
    defWight:nodesDefWight,
  },
})

export const setPickedNodeId = (newId) => ({
  type:SET_PICKED_NODE_ID,
  payload:newId
})

const _reformatContext = (context) => {
  let newContext = {}
  context.map(nodeContext => newContext[nodeContext.node] = nodeContext)
  return newContext;
}

export const setPickedTreeId = (newId) => async (dispatch, getState) => {
  const curTreeId = getState().preferenceTree.id;
  if(newId === curTreeId){
    return ;
  }
  console.log(`setting tree id: ${newId}`)
  dispatch({
        type:SET_PICKED_TREE_ID,
        payload:newId
        })
  const data = await getTreeData(newId)
  console.log("got tree data")
  console.log(data)
  dispatch(setTreeData(data))

  if(data.default_context){
    /* Got Defualt Context */
    const treeContext = _reformatContext(data.default_context.nodes_context)
    console.log("got defualt context");
    console.log(treeContext);
    dispatch(setTreeContext(treeContext))
    return ;
  }
  /* no tree context was found set empty*/
  dispatch(setTreeContext({}))
}

export const setTreeContext = (treeContext) => ({
  type:SET_TREE_CONTEXT,
  payload:treeContext,
})

export const setNodeContext = (id, nodeContext) => ({
  type:SET_NODE_CONTEXT,
  payload:{nodeContext:nodeContext,
          id:id}
})

export const setNodeFunctionData = (id, functionData) => ({
  type:SET_NODE_FUNCTION_DATA,
  payload:{functionData:functionData,
          id:id}
})

export const setTreeBuildData = (newBuild) => ({
  type:SET_TREE_BUILD_DATA,
  payload:newBuild
})

export const setNodesData = (newNodesData) => ({
  type:SET_NODES_DATA,
  payload:newNodesData
})

export const setTreeContextById = (contextId, processId) => async (dispatch) => {
  /* start uploading */
  dispatch(_addProcess(processId));
  try{
      const treeContextData = await getTreeContext(contextId)
      console.log("got tree context");
      console.log(treeContextData);
      const treeContext = treeContextData.nodes_context
      console.log(treeContext);
      dispatch(setTreeContext( _reformatContext(treeContext)))
      dispatch(_setProcessState(processId, SUCSSES))
  } catch(err){
    console.log(err);
    dispatch(_setProcessState(processId, ERROR))
  }
};


export const uploadTreeContext = (nodes_context, processId) => async (dispatch) => {
  /* start uploading */
  console.log("start process: upload tree context");
  console.log(nodes_context);
  dispatch({ type: UPLOAD_CONTEXT_SENT });
  dispatch(_addProcess(processId));
  let nodes_context_list = []
  for (let [key, value] of Object.entries(nodes_context)) {
    value.node = key;
    nodes_context_list.push(value)
  }
  let treeContext = {tree: 1,
                      category: 1,
                      nodes_context:nodes_context_list} // TODO: fir testing upload before try with real context
  try{
      /* a check for pas1==pas2 is done also on server side and in compponent*/
      const uploadData = await dbUploadTreeContext(treeContext);
      console.log("finished process: upload tree context");
      console.log(uploadData);
      dispatch({
        type: UPLOAD_CONTEXT_SUCCESS,
        payload: uploadData
        });
        dispatch(_setProcessState(processId, SUCSSES))
  } catch(err){
    console.log("failed process: upload tree context");
    console.log(err);
    dispatch(_setProcessState(processId, ERROR))
    /*dispatch(returnErrors(err.response.data, err.response.status));*/
    dispatch({
      type: UPLOAD_CONTEXT_FAIL,
    });
  }
};

export const setTreeData = (newTreeData) => {
  console.log(`setting new tree data: ${newTreeData.title}`);
  return ({
    type: SET_TREE_DATA,
    payload: newTreeData
  })
}

export const setNodeWight = (id, wight) => {
  console.log(`setting node ${id} wight: ${wight}`);
  return {
    type: SET_NODE_WIGHT,
    payload: {
      id:id,
      wight:wight,
    }
  }
}


/* ****** AUTH ACTIONS creators ******* */

export const loadUser = (processId) => async (dispatch, getState) => {
  console.log("action to load user");
  dispatch({ type: USER_LOADING });
  _addProcess(processId)
  try{
    const loadUserResult = await loadUserFromDb(getState().auth.key)
    if (loadUserResult.detail === "Invalid token."){
      console.log("auth error called");
      dispatch({
        type: AUTH_ERROR,
      });
      _setProcessState(processId, ERROR)
      return ;
    }
    dispatch({
      type: USER_LOADED,
      payload: loadUserResult.username
    });
    _setProcessState(processId, SUCSSES)
  } catch(err){
    console.log(err);
    console.log("auth error called");
      /*dispatch(returnErrors(err.response.data, err.response.status));*/
    dispatch({
      type: AUTH_ERROR,
    });
  }
};

// LOGIN USER
export const login = (user, email, password, processId) => async (dispatch) => {
  dispatch({ type: LOG_IN_SENT });
  dispatch(_addProcess(processId));
  try{
    console.log("action login creator was called");
    const loginData = await logInUser(user, email, password);
    console.log("got login data");
    console.log(loginData);
    dispatch({
      type: LOG_IN_FULFILLED,
      payload: {user,
        ...loginData,
        }
    });
    dispatch(_setProcessState(processId, SUCSSES))
  }catch(err){
    console.log("login failed");
    console.log(err);
    /*dispatch(returnErrors(err.response.data, err.response.status));*/
    dispatch({
      type: LOG_IN_REJECTED,
    });
    dispatch(_setProcessState(processId, ERROR))
  }
};


// REGISTER USER
export const register = ({user, email, password1,  password2}, processId) => async (dispatch) => {
  dispatch({ type: REGISTER_SENT });
  dispatch(_addProcess(processId));
  console.log(`registering user ${user}`);
  try{
      /* a check for pas1==pas2 is done also on server side and in compponent*/
      const registerData = await registerUserDb(user, email, password1, password2);
      console.log("register data");
      console.log(registerData);
      dispatch({
        type: REGISTER_SUCCESS,
        payload: {user,
          ...registerData,
          }
        }
      );
      dispatch(_setProcessState(processId, SUCSSES))
  } catch(err){
    /*dispatch(returnErrors(err.response.data, err.response.status));*/
    dispatch({
      type: REGISTER_FAIL,
    });
    dispatch(_setProcessState(processId, ERROR))
    let errors = [];
    for (const [dataName, dataErrors] of Object.entries(err)) {
      const dataErrorsString = dataErrors.map(error=>(`${dataName}: ${error}`))
      errors = [...errors, ...dataErrorsString]
    }
    dispatch(_setErrors(processId, errors))
  }
};

// LOGOUT USER
export const logout = () => async (dispatch, getState) => {
  try{
      /* a check for pas1==pas2 is done also on server side and in compponent*/
      const logoutData = await logoutUserDb(getState().auth.key);
      dispatch({
        type: LOGOUT_SUCCESS,
        payload: logoutData,
      });
  } catch(err){
      console.log(err);
    /*dispatch(returnErrors(err.response.data, err.response.status));*/
    dispatch({
      type: LOGOUT_FAULIRE,
    });
  }
};

/* **************** options action creators ************* */


export const setPagintationData = (paginationData) => {
  console.log("setting pagination data");
  console.log(paginationData);
  return (
  {
    type: SET_PAGINTATION_DATA,
    payload: paginationData,
  }
)}


const _loadOptionHelper = async (queryData, prop, nodesData, url, dispatch, getState) => {
  console.log("loading options:");
  console.trace()
  console.log(queryData);
  console.log(nodesData);
  try{
      /* set chosen option category: */
      const optionMetaData = await dbGetOptionMetaData(queryData?queryData.category:null);
      dispatch({
        type: SET_OPTION_META_DATA,
        payload: optionMetaData,
      });
      dispatch({
        type: LOADING_OPTIONS,
        payload: null,
      });
      /* load meta data for options: */

      const optionsResults = await getOptions(queryData,prop, nodesData, url);
      const result_sorted = optionsResults.results.sort((a, b)=> {
            if ( a.score > b.score ){
              return -1;
            }
            if ( a.score < b.score ){
              return 1;
            }
            return 0;
          })
      console.log(optionsResults);
      dispatch({
        type: LOADED_OPTIONS,
        payload: result_sorted,
      });
      let pagintationData = {count: optionsResults.count,
                        next:optionsResults.next,
                        previous: optionsResults.previous,
                        lastPage: optionsResults.lastPage,
                        itemsOnPage:optionsResults.itemsOnPage,
                        current: optionsResults.current,
                      }
      dispatch(setPagintationData(pagintationData));

      const optionsId = optionsResults.results.map(result => result.id)
      console.log("options id");
      console.log(optionsId);
      const extandedScores = await getExtendedScores(optionsId,store.getState().nodesData)
      dispatch({
        type: SET_EXTENDED_SCORES,
        payload: extandedScores,
      });
      console.log("got extended results");
  } catch(err){
    console.log("error:");
      console.log(err);
      dispatch({
        type: ERROR_LOADING_OPTIONS,
        payload: null,
      });
  }
}

const thrrotleTimeWait = 4000;

const _throttledLoadOptionsHelper =  throttle(async  (queryData, prop, nodesData, url, dispatch, getState) => {
              return await _loadOptionHelper(queryData, prop, nodesData, url, dispatch, getState)},
              thrrotleTimeWait, {
              leading: true
            });

export const loadOptions = (queryData, nodesData, url) => async (dispatch, getState) => {
  console.log("using unthrotle load options");
  console.trace()
   await _loadOptionHelper(store.getState().optionQueryParams,
      store.getState().nodesData,
      url, dispatch, getState);
};

export const throttledLoadOptions  = (prop, url) => async (dispatch, getState) => {
  console.log("using throtle load options");
  dispatch({type:INCREASE_COUNTER})
  console.log(store.getState().userNodesDate);
  await _throttledLoadOptionsHelper(store.getState().optionQueryParams, prop,
                          store.getState().nodesData , url, dispatch, getState);
  dispatch({type:DECREASE_COUNTER})
};




export const setChosenOptionCategory = (category) => async (dispatch, getState) => {
  try{
      /* set chosen option category: */
      console.log("starting to change category action");
      const oldCategory = getState().options.chosenOptionsCategory;
      if(oldCategory === category){
        return;
      }
      dispatch({
        type: SET_CHOSEN_OPTION_CATEGORY,
        payload: category,
      });
      /* load meta data for options: */
      const optionMetaData = await dbGetOptionMetaData(category);
      dispatch({
        type: SET_OPTION_META_DATA,
        payload: optionMetaData,
      });
      /* load options: */
      await loadOptions({category:category}) (dispatch, getState);
  } catch(err){
      console.log(err);
  }
};

export const resortOptions = (tree) => ({
  type: RESORT_OPTIONS,
  payload: tree
})

export const addOptionQueryParam = (name, value) => {
    return ({
      type: ADD_OPTION_QUERY_PARAM,
      payload: {
        name,
        value
      }
    });
}

export const deleteOptionQueryParam = name => (
    {type: DELETE_OPTION_QUERY_PARAM,
      payload: name}
)

export const addFilter = (name, value) => {
    return ({
      type: ADD_FILTER,
      payload: {
        name,
        value
      }
    });
}

export const deleteFilter = name => (
    {type: DELETE_FILTER,
      payload: name}
)

export const setOptionDisplay = (value) => {
  return {
      type: SET_OPTIONS_DISPLAY,
      payload: value,
  }
}

export const setControlOptionDisplay = (value) => {
  return {
      type:SET_CONTROL_OPTIONS_DISPLAY ,
      payload:value,
  }
}


export const addBreadcrumb = (title, url) => {
  return {
      type:ADD_BREAD_CRUMB,
      payload:{title:title, url:url},
  }
}



export const setPrefernceItem = prefItem =>
(
    {type: SET_PREFERNCE_ITEM,
      payload: prefItem}
)
